import { Component } from '@angular/core';

@Component({
  selector: 'app-gen-header-result',
  standalone: false,
  templateUrl: './gen-header-result.component.html',
  styleUrl: './gen-header-result.component.scss'
})
export class GenHeaderResultComponent {

}
